import HangingMenus from "../common-components/HangingMenus";
import "./SocialLearning.css";

const SocialLearning = () => {
  return (
    <div>
      {/* banner Image */}
      <img
        className="SL__banner"
        src="/images/SocialLearning/Social_Banner.png"
        alt="banner"
      />

      {/* About text */}
      <div className="SL__about__text">
        <br></br>
        <h2>Learn. Connect. Grow!</h2>
        <br />
        {/* <h2>Time to collaborate and learn with your peers!/Collaborate for a more enriching learning journey</h2> */}
        <p className="SL__about__P">
          Learning is not always fun. Contrarily, given that it’s often arduous
          to master new knowledge is what makes learning a valuable endeavor.
          Connecting with fellow learners can make your laborious learning
          journey less tiresome and solitary. Knowing how their perspectives
          differ on a course may broaden your depth of that course. While
          sharing your learning journey on Yammer may foster new and valuable
          professional connections. Social learning is an essential element of
          all learning. So, make the best of it by joining the Enterprise Platforms Yammer group.
          And connect, collaborate, and grow!
        </p>
        <br></br>
      </div>

      {/* Conntect with Yammer community div */}

      <div className="SL__yammer__div">
        <h2>Connect with the Yammer community</h2>
        <div className="SL__yammer__gridContainer">
          {/* 1st Salesforce */}
          {/* <a href="#" target="_blank" style={{ textDecoration: "none" }}> */}
            <div className="SL__yammer__gridItem">
              <div className="SL__grid__buttons">
                {" "}
                <div className="SL__grid__buttons__icons">
                  <img
                    className="SL__button__icon__images"
                    src="images/SocialLearning/Salesforce.png"
                    alt="oracle-icon"
                  />
                </div>
                ATCI Enterprise Platforms Salesforce Business Group
              </div>
            </div>
          {/* </a> */}

          {/* 2nd Oracle */}
          <a
            target="_blank"
            style={{ textDecoration: "none" }}
            href="https://web.yammer.com/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiI3OTUzMTgyNzIwMCJ9/all"
          >
            <div className="SL__yammer__gridItem">
              <div className="SL__grid__buttons">
                {" "}
                <div className="SL__grid__buttons__icons">
                  <img
                    className="SL__button__icon__images"
                    src="images/SocialLearning/Oracle.png"
                    alt="oracle-icon"
                  />
                </div>
                ATCI Enterprise Platforms Oracle Business Group
              </div>
            </div>
          </a>

          {/* 3rd Workday */}
          {/* <div className="SL__yammer__gridItem">
            <div className="SL__grid__buttons">
              {" "}
              <div className="SL__grid__buttons__icons">
                <img
                  className="SL__button__icon__images"
                  src="images/SocialLearning/Workday.png"
                  alt="oracle-icon"
                />
              </div>
              ATCI Enterprise Platforms Workday Business Group
            </div>
          </div> */}

          {/* 2nd SAP */}
          <a
            target="_blank"
            style={{ textDecoration: "none" }}
            href="https://web.yammer.com/main/org/accenture.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiI1NzgyMjY5OTUyMCJ9"
          >
            <div className="SL__yammer__gridItem">
              <div className="SL__grid__buttons">
                {" "}
                <div className="SL__grid__buttons__icons">
                  <img
                    className="SL__button__icon__images"
                    src="images/SocialLearning/SAP.png"
                    alt="oracle-icon"
                  />
                </div>
                ATCI Enterprise Platforms SAP Business Group
              </div>
            </div>
          </a>
        </div>
      </div>
      <HangingMenus />
    </div>
  );
};

export default SocialLearning;
